import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withReducer from '@Hooks/withReducer';
import { relativeContextItemsByHitSetKey } from '@Containers/RelativeContext/RelativeContextSelectors';
import ListOfFilters from './ListOfFilters';
import { listOfFiltersReducerKey } from './ListOfFiltersConstants';
import { areParamsForFiltersRequestValid } from './ListOfFiltersUtils';
import listOfFiltersReducer from './ListOfFiltersReducer';
import {
  filters as filtersSelector,
  paramsForFiltersRequest as paramsForFiltersRequestSelector,
  keyifyParamsForFiltersRequest as keyifyParamsForFiltersRequestSelector,
} from './ListOfFiltersSelectors';
import {
  fetchFilters as fetchFiltersAction,
  toggleFilter as toggleFilterAction,
  enableCrossContextFiltersWhenGotRelativeContexts as enableCrossContextFiltersWhenGotRelativeContextsAction,
} from './ListOfFiltersActions';

export function ListOfFiltersContainer(props) {
  const {
    filters,
    paramsForFiltersRequest,
    keyifyParamsForFiltersRequest,
    fetchFilters,
    relativeContextItems,
    enableCrossContextFiltersWhenGotRelativeContexts,
  } = props;

  const loadFilters = () => {
    if (filters) {
      return;
    }

    if (!areParamsForFiltersRequestValid(paramsForFiltersRequest)) {
      return;
    }

    Logger.info('Loading filters...');
    fetchFilters(paramsForFiltersRequest, keyifyParamsForFiltersRequest);
  };

  useEffect(() => {
    loadFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsForFiltersRequest]);

  useEffect(() => {
    if (relativeContextItems) {
      enableCrossContextFiltersWhenGotRelativeContexts({
        key: keyifyParamsForFiltersRequest,
        params: paramsForFiltersRequest,
        relativeContextItems,
        filters,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relativeContextItems]);

  return <ListOfFilters {...props} />;
}

ListOfFiltersContainer.propTypes = {
  filters: PropTypes.instanceOf(List),
  paramsForFiltersRequest: PropTypes.object,
  keyifyParamsForFiltersRequest: PropTypes.string,
  fetchFilters: PropTypes.func,
};

function mapStateToProps(state) {
  const paramsForFiltersRequest = paramsForFiltersRequestSelector(state);
  const { hitSetKey } = paramsForFiltersRequest || {};
  const relativeContextItems = relativeContextItemsByHitSetKey(state, { hitSetKey });
  return {
    filters: filtersSelector(state),
    paramsForFiltersRequest,
    keyifyParamsForFiltersRequest: keyifyParamsForFiltersRequestSelector(state),
    relativeContextItems,
  };
}

const mapDispatchToProps = {
  fetchFilters: fetchFiltersAction,
  toggleFilter: toggleFilterAction,
  enableCrossContextFiltersWhenGotRelativeContexts: enableCrossContextFiltersWhenGotRelativeContextsAction,
};

export default compose(
  withReducer(listOfFiltersReducerKey, listOfFiltersReducer, true),
  connect(mapStateToProps, mapDispatchToProps)
)(ListOfFiltersContainer);
